import React from 'react';
import { Avatar } from './Avatar';
const testimonials = [{
  quote: <>
        "Yetu gave Tende a face people trust in seconds — the brand and the app
        finally <em data-id="element-263">feel like the same product</em>."
      </>,
  author: 'Abel',
  role: 'CEO, TendePay'
}, {
  quote: <>
        "We finally look like the company we are. A mark people{' '}
        <em data-id="element-264">remember</em> and a site that does the selling for us."
      </>,
  author: 'Amos',
  role: 'Co-founder, Nova Cloud'
}, {
  quote: <>
        "The rebrand made us look like the <em data-id="element-265">premium studio</em> we are.
        Bookings picked up almost immediately."
      </>,
  author: 'Lisa',
  role: 'Manager, Pixel Paints'
}, {
  quote: <>
        "They turned a pile of spreadsheets into a product our customers{' '}
        <em data-id="element-266">actually love</em>."
      </>,
  author: 'Doris',
  role: 'CEO, FlowKey Labs'
}];
export function Testimonials() {
  return <section className="sec" data-id="element-267">
      <div className="sec__head" data-id="element-268">
        <div data-id="element-269">
          <div className="eyebrow mb-5" data-id="element-270">Testimonials</div>
          <h2 data-id="element-271">What clients say</h2>
        </div>
      </div>

      <div className="quotes" data-id="element-272">
        {testimonials.map((item, index) => <figure key={index} className="quote" data-id="element-273">
            <blockquote className="q" data-id="element-274">{item.quote}</blockquote>
            <figcaption className="who" data-id="element-275">
              <Avatar name={item.author} data-id="element-276" />
              <div data-id="element-277">
                <b data-id="element-278">{item.author}</b>
                <span data-id="element-279">{item.role}</span>
              </div>
            </figcaption>
          </figure>)}
      </div>
    </section>;
}